import * as countries from 'i18n-iso-countries';
import {
  postcodeValidator,
  postcodeValidatorExistsForCountry,
} from 'postcode-validator';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export const COUNTRIES = Object.entries(
  countries.getNames('en', { select: 'alias' }),
).map(([iso_code, name]) => ({
  value: iso_code,
  label: name,
}));

export function getCountryName(iso_code: string): string {
  return COUNTRIES.find((country) => country.value === iso_code)?.label ?? '';
}

export function isValidZipCode(zip: string, countryCode: string): boolean {
  if (!countryCode) return false;
  if (countryCode === 'CA') return true; // for now, skip regex for canada
  if (postcodeValidatorExistsForCountry(countryCode)) {
    return postcodeValidator(zip, countryCode);
  }
  return false;
}
